import { CategoriesGridProvider } from '@components/CategoriesGrid/CategoriesGridProvider'

export const withCategoriesGrid = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
) => {
  return function (props: P) {
    return (
      <CategoriesGridProvider>
        <WrappedComponent {...props} />
      </CategoriesGridProvider>
    )
  }
}
